import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const FactoryDeadlineDialog = ({ orderId, currentValue, open, onOpenChange, onSaved }) => {
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setValue((currentValue || '').slice(0, 10));
  }, [open, currentValue]);

  const submit = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/orders/${orderId}/factory-deadline`, { factory_deadline: value || null });
      toast.success(value ? 'Factory deadline saved' : 'Factory deadline cleared');
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed');
    } finally { setSaving(false); }
  };

  const clear = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/orders/${orderId}/factory-deadline`, { factory_deadline: null });
      toast.success('Factory deadline cleared');
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="factory-deadline-dialog">
        <DialogHeader>
          <DialogTitle>Set Factory Deadline</DialogTitle>
          <DialogDescription>
            This deadline is shown only to the factory and is independent of the customer delivery date. The casting timeline is not affected.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Deadline</Label>
            <Input
              type="date"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              data-testid="factory-deadline-input"
            />
          </div>
        </div>
        <DialogFooter className="gap-2 sm:gap-2">
          {currentValue && (
            <Button variant="outline" onClick={clear} disabled={saving} className="mr-auto text-rose-600 hover:text-rose-700" data-testid="factory-deadline-clear">
              Clear
            </Button>
          )}
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={submit} disabled={saving || !value} data-testid="factory-deadline-save">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FactoryDeadlineDialog;
